// extracted by mini-css-extract-plugin
module.exports = {"price":"CardPrices_price__NBGhV","prices":"CardPrices_prices__ziHc_","scalable":"CardPrices_scalable__AUhGI","sale":"CardPrices_sale__l_ZXw"};